import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=8be4bb44&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=8be4bb44&prod&lang=scss&scoped=true"
import style1 from "./productDetail.vue?vue&type=style&index=1&id=8be4bb44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be4bb44",
  null
  
)

export default component.exports